<template>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `productCategories/${inputs.id}` : `productCategories`'>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('name') }}</label>
                            <app-input type="text" v-model="inputs.name" :placeholder="$t('type_name')"
                                :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('code') }}</label>
                            <app-input type="text" v-model="inputs.code" :placeholder="$t('type_code')"
                                :required="true" />
                        </div>
                    </div>
                </div>

                <div style="padding-bottom: 120px"></div>
            </form>
        </template>
    </modal>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
    name: "AddProductCategoryModal",
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: String
    },
    data() {
        return {
            preloader: false,
            inputs: {
                category : null

            },
            modalId: 'product-category-add-edit-modal',
            modalTitle: this.$t('add'),
        }
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
    methods: {
        submit() {
            let saveInput = {
                name: this.inputs.name,
                id: this.inputs.id,
                code: this.inputs.code,
                category_id: this.inputs.category ? this.inputs.category.id : null,
            }
            this.save(saveInput);
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            if (response.data.phone) this.phone = response.data.phone;
            this.inputs = response.data;
            this.preloader = false;
        },
        searchAndSelectCategory() {
            this.axiosGet(actions.PRODUCT_CATEGORIES_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));
                if (response.data) {
                    name.option = response.data.map(name => {
                        return {
                            id: name.name,
                            value: name.name
                        }
                    });
                }
            });
        },
    },
}
</script>
